export default "__VITE_ASSET__Dpc7y4kK__"